import Vue from 'vue';
import BzbsApi from '@/core/Http/BzbsApi.js';
import DashboardModel from '../model/DashboardModel.js';

/**
 * @method apiGetDashboard
 * @method apiGetSubDashboard
 */
export default {
    config: function() {
        return Vue.bzbsConfig;
    },

    /**
     * Get main dashboard
     * @param {object} params DashboardConfigModel - /core/Campaign/model/DashboardConfigModel.js
     * @return {Promise} list of DashboardModel
     */
    apiGetDashboard: function(params) {
        var strUrl = this.config().bzbsUrl + "/main/dashboard";
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsGet(strUrl, null, params).then((resp) => {
                var data = resp.data;
                if (data instanceof Array) {
                    var listDashboard = [];
                    for (var i of data) {
                        listDashboard.push(new DashboardModel(i));
                    }
                    resolve(listDashboard);
                } else {
                    reject(null);
                }
            }).catch((error) => {
                reject(error);
            });
        });
    },

    /**
     * Get custom dashboard
     * @param {string} strBzbsToken (optional)
     * @param {object} params (require) SubDashboardConfigModel  - /service/config/DashboardConfigModel.js
     * @return {Pormoise} list of DashboardModel
     */
    apiGetSubDashboard: function(strBzbsToken, params, dashboardName) {
        var strUrl = this.config().bzbsUrl + "/dashboard/" + dashboardName;
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsGet(strUrl, strBzbsToken, params).then((resp) => {
                var data = resp.data;
                if (data instanceof Array) {
                    var listDashboard = [];
                    for (var i of data) {
                        listDashboard.push(new DashboardModel(i));
                    }
                    resolve(listDashboard);
                } else {
                    reject(null);
                }
            }).catch((error) => {
                reject(error);
            });
        });
    },
}
